import { defineAsyncComponent } from 'vue'
export default {
  strapi: defineAsyncComponent(() => import("/app/apps/mini/layouts/strapi.vue").then(m => m.default || m))
}